import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
  Typography,
  CircularProgress,
  Box,
  IconButton,
  makeStyles,
  MenuItem,
  Chip,
  DialogContentText,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { ChevronRight } from "@material-ui/icons";
import BackDropLoading from "../../../../pcmp/components/common/models/BackDrop";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import EventTwoToneIcon from "@material-ui/icons/EventTwoTone";
import { format } from "date-fns";
import moment from "moment";
import { updateDeliveryScheduleForecast } from "../../../containers/actions/common/forecastScheduleActions";
import { useDispatch, useSelector } from "react-redux";
import usePrevious from "../../../helpers/previousProps";

const useStyles = makeStyles((theme) => ({
  titleGrid: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    // padding: '1rem',
  },
  head: {
    textAlign: "center",
  },
  closeBtn: {
    display: "flex",
    alignItems: "center",
    position: "absolute",
    top: "12px",
    right: "10px",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
      color: "#FF0000",
    },
  },
  cancelBtn: {
    border: "1px solid #000000de",
    backgroundColor: "white",
    color: "black",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "black",
      color: "white",
      border: "1px solid #000000de",
    },
  },
  table: {
    // width: "100%",
    marginBottom: "20px",
  },
  tableCell: {
    borderBottom: "none", // Optional: Remove default bottom borders
    padding: "8px 16px",
    fontSize: "14px", // Adjust the font size if needed
    fontWeight: "500",
  },
  tableHeadCell: {
    borderBottom: "none",
    fontWeight: "bold",
    fontSize: "14px",
    padding: "8px 16px",
    textAlign: "left",
  },
}));

const NewDeliverySchedulePopup = (props) => {
  const {
    handleDeliveryScehdulePopup,
    openDialog,
    dsForecastDetails,
    schedule,
    hasProposedScheduleCDMOProp,
    hasProposedScheduleSponsorProp,
    hasFinalScheduleProp,
    hasLastAgreedScheduleProp,
    collaboratorTypeID,
    loggedInCollaboratorTypeID,
    handleUpdateSuccess,
  } = props;
  const classes = useStyles();

  const dispatch = useDispatch();

  const deepCopyList = (list) => {
    return list.map((item) => ({ ...item })); // Create a new array of shallow-copied objects
  };

  const [rows, setRows] = useState(
    deepCopyList(dsForecastDetails.deliveryScheduleForecastDetailsList).map(
      (row) => {
        // Create a copy of the current row to avoid mutating the original list
        const updatedRow = { ...row };

        // If collaborator type is "Pharma Co", set sponsor fields from last agreed if sponsor fields are null
        // if (localStorage.collabType === "Pharma Co") {
        //   if (
        //     updatedRow.lastAgreedDeliveryDate &&
        //     !updatedRow.proposedDeliveryDateSponsor
        //   ) {
        //     updatedRow.proposedDeliveryDateSponsor =
        //       updatedRow.lastAgreedDeliveryDate;
        //   }

        //   if (
        //     updatedRow.lastAgreedQuantity &&
        //     !updatedRow.proposedQuantitySponsor
        //   ) {
        //     updatedRow.proposedQuantitySponsor = updatedRow.lastAgreedQuantity;
        //   }
        // }

        // If collaborator type is not "Pharma Co", set CDMO fields from sponsor fields if CDMO fields are null
        // if (localStorage.collabType !== "Pharma Co") {
        //   if (
        //     updatedRow.proposedDeliveryDateSponsor &&
        //     !updatedRow.proposedDeliveryDateCDMO
        //   ) {
        //     updatedRow.proposedDeliveryDateCDMO =
        //       updatedRow.proposedDeliveryDateSponsor;
        //   }

        //   if (
        //     updatedRow.proposedQuantitySponsor &&
        //     !updatedRow.proposedQuantityCDMO
        //   ) {
        //     updatedRow.proposedQuantityCDMO =
        //       updatedRow.proposedQuantitySponsor;
        //   }
        // }

        return updatedRow; // Return the modified row with sponsor or CDMO fields set
      }
    )
  );

  //   const [hasLastAgreedSchedule, setHasLastAgreedSchedule] = useState(
  //     rows.some((row) => row.lastAgreedDeliveryDate)
  //   );
  //   const [hasProposedScheduleSponsor, setHasProposedScheduleSponsor] = useState(
  //     rows.some((row) => row.proposedDeliveryDateSponsor)
  //   );
  //   const [hasProposedScheduleCDMO, setHasProposedScheduleCDMO] = useState(
  //     rows.some((row) => row.proposedDeliveryDateCDMO)
  //   );
  //   const [hasFinalSchedule, setHasFinalSchedule] = useState(
  //     rows.some((row) => row.finalDeliveryDate)
  //   );

  //   const handleDateChange = (date, index, fieldToUpdate) => {
  //     // Create a new array by mapping the existing rows
  //     const updatedRows = rows.map((row, idx) =>
  //       idx === index
  //         ? {
  //             ...row,
  //             [fieldToUpdate]: moment(date).format("YYYY-MM-DDTHH:mm:ss"),
  //           }
  //         : row
  //     );

  //     // Update the state with the new rows array
  //     setRows(updatedRows);

  //     // Update other state conditions
  //     setHasProposedScheduleCDMO(
  //       updatedRows.some((row) => row.proposedDeliveryDateCDMO)
  //     );
  //     setHasProposedScheduleSponsor(
  //       updatedRows.some((row) => row.proposedDeliveryDateSponsor)
  //     );
  //     setHasFinalSchedule(updatedRows.some((row) => row.finalDeliveryDate));
  //     setHasLastAgreedSchedule(
  //       updatedRows.some((row) => row.lastAgreedDeliveryDate)
  //     );
  //   };

  const handleDateChange = (date, index, fieldToUpdate) => {
    // Create a new array by mapping the existing rows
    const updatedRows = rows.map((row, idx) =>
      idx === index
        ? {
            ...row, // Preserve all other fields
            [fieldToUpdate]: moment(date).format("YYYY-MM-DDTHH:mm:ss"), // Only update the specific date field
          }
        : row
    );

    // Update the state with the new rows array
    setRows(updatedRows);

    // Update other state conditions (if necessary)
    // setHasProposedScheduleCDMO(
    //   updatedRows.some((row) => row.proposedDeliveryDateCDMO)
    // );
    // setHasProposedScheduleSponsor(
    //   updatedRows.some((row) => row.proposedDeliveryDateSponsor)
    // );
    // setHasFinalSchedule(updatedRows.some((row) => row.finalDeliveryDate));
    // setHasLastAgreedSchedule(
    //   updatedRows.some((row) => row.lastAgreedDeliveryDate)
    // );
  };

  const handleQuantityChange = (quantity, index, fieldToUpdate) => {
    // Create a new array by mapping the existing rows
    const updatedRows = rows.map((row, idx) =>
      idx === index
        ? {
            ...row, // Preserve all other fields
            [fieldToUpdate]: quantity, // Only update the specific quantity field
          }
        : row
    );

    // Update the state with the new rows array
    setRows(updatedRows);
  };

  //   useEffect(() => {
  //     if (openDialog) {
  //       // Reset rows to the original data when the dialog is opened
  //       setRows(dsForecastDetails.deliveryScheduleForecastDetailsList);

  //       // Reset the schedule states
  //       setHasProposedScheduleCDMO(
  //         dsForecastDetails.deliveryScheduleForecastDetailsList.some(
  //           (row) => row.proposedDeliveryDateCDMO
  //         )
  //       );
  //       setHasProposedScheduleSponsor(
  //         dsForecastDetails.deliveryScheduleForecastDetailsList.some(
  //           (row) => row.proposedDeliveryDateSponsor
  //         )
  //       );
  //       setHasFinalSchedule(
  //         dsForecastDetails.deliveryScheduleForecastDetailsList.some(
  //           (row) => row.finalDeliveryDate
  //         )
  //       );
  //       setHasLastAgreedSchedule(
  //         dsForecastDetails.deliveryScheduleForecastDetailsList.some(
  //           (row) => row.lastAgreedDeliveryDate
  //         )
  //       );
  //     }
  //   }, [openDialog, dsForecastDetails]);

  const handleSave = () => {
    const originalList = deepCopyList(
      dsForecastDetails.deliveryScheduleForecastDetailsList
    ); // Work with a copy of the original list
    const collabType = localStorage.getItem("collbType");

    //console.log("Original List: ", originalList);
    //console.log("Current Rows: ", rows);

    // Find the rows that have changed
    const changedRows = rows
      .map((row, index) => {
        const originalRow = originalList[index]; // Work on a copy of the original data

        // Flags for date and quantity changes
        let changeInDate = false;
        let changeInQty = false;

        // Compare dates
        if (loggedInCollaboratorTypeID === 1) {
          if (
            originalRow.proposedDeliveryDateSponsor &&
            row.proposedDeliveryDateSponsor &&
            moment(row.proposedDeliveryDateSponsor).format("YYYY-MM-DD") !==
              moment(originalRow.proposedDeliveryDateSponsor).format(
                "YYYY-MM-DD"
              )
          ) {
            changeInDate = true;
          } else if (
            !originalRow.proposedDeliveryDateSponsor &&
            row.proposedDeliveryDateSponsor &&
            moment(row.proposedDeliveryDateSponsor).format("YYYY-MM-DD") !==
              moment(originalRow.lastAgreedDeliveryDate).format("YYYY-MM-DD")
          ) {
            changeInDate = true;
          }
        }

        if (loggedInCollaboratorTypeID === 2) {
          if (
            originalRow.proposedDeliveryDateCDMO &&
            row.proposedDeliveryDateCDMO &&
            moment(row.proposedDeliveryDateCDMO).format("YYYY-MM-DD") !==
              moment(originalRow.proposedDeliveryDateCDMO).format("YYYY-MM-DD")
          ) {
            changeInDate = true;
          } else if (
            !originalRow.proposedDeliveryDateCDMO &&
            row.proposedDeliveryDateCDMO &&
            moment(row.proposedDeliveryDateCDMO).format("YYYY-MM-DD") !==
              moment(originalRow.lastAgreedDeliveryDate).format("YYYY-MM-DD")
          ) {
            changeInDate = true;
          }
        }

        // Compare quantities

        if (loggedInCollaboratorTypeID === 1) {
          if (
            originalRow.proposedQuantitySponsor &&
            row.proposedQuantitySponsor &&
            parseInt(row.proposedQuantitySponsor) !==
              originalRow.proposedQuantitySponsor
          ) {
            //console.log("1");
            changeInQty = true;
          } else if (
            !originalRow.proposedQuantitySponsor &&
            row.proposedQuantitySponsor &&
            parseInt(row.proposedQuantitySponsor) !==
              originalRow.lastAgreedQuantity
          ) {
            // console.log(
            //   "row.proposedQuantitySponsor",
            //   typeof row.proposedQuantitySponsor
            // );
            // console.log(
            //   "original.lastAgreedQuantity",
            //   typeof originalRow.lastAgreedQuantity
            // );
            // console.log("2");
            changeInQty = true;
          }
        }

        if (loggedInCollaboratorTypeID === 2) {
          if (
            originalRow.proposedQuantityCDMO &&
            row.proposedQuantityCDMO &&
            parseInt(row.proposedQuantityCDMO) !==
              originalRow.proposedQuantitySponsor
          ) {
            changeInQty = true;
          } else if (
            !originalRow.proposedQuantityCDMO &&
            row.proposedQuantityCDMO &&
            parseInt(row.proposedQuantityCDMO) !==
              originalRow.proposedQuantitySponsor
          ) {
            changeInQty = true;
          }
        }

        // If either the date or quantity has changed, return the updated row with flags
        if (changeInDate || changeInQty) {
          return {
            ...row, // Return the current row data (modified as needed)
            changeInDate,
            changeInQty,
            // Convert quantity fields from string to number
            proposedQuantitySponsor: row.proposedQuantitySponsor
              ? parseFloat(row.proposedQuantitySponsor)
              : null,
            proposedQuantityCDMO: row.proposedQuantityCDMO
              ? parseFloat(row.proposedQuantityCDMO)
              : null,
            lastAgreedQuantity: row.lastAgreedQuantity
              ? parseFloat(row.lastAgreedQuantity)
              : null,
          };
        }

        // Return null if no changes to avoid including unchanged rows
        return null;
      })
      .filter((row) => row !== null); // Filter out unchanged rows (null)

    //console.log("Changed rows:", changedRows);

    // Prepare the request object with only changed rows
    const requestObject = {
      status: schedule.status,
      sponsorOrgID: schedule.sponsorOrgID,
      cdmoOrgID: schedule.cdmoOrgID,

      collabrixForecastScheduleID: schedule.collabrixForecastScheduleID,

      //   scheduleAcceptedFlag: schedule.collabrixForecastScheduleID,
      scheduleProposedFlag: true,
      //   statusChangeFlag:
      //     schedule.status === "Forecast Schedule Approved" ||
      //     schedule.status === "Forecast Schedule Created"
      //       ? true
      //       : false,
      //   scheduleFinalizedFlag: schedule.scheduleFinalizedFlag,

      deliveryScheduleForecastDetailsList: changedRows,
    };

    // Log the final request object
    //console.log("Request object to be sent:", requestObject);
    dispatch(updateDeliveryScheduleForecast(requestObject));
    // Example of handling the save logic, replace this with your API call logic:
    // sendSaveRequest(requestObject).then(response => {
    //   // Handle response
    // });
  };

  const errRef = useRef();
  const scrollToTop = () => {
    setTimeout(
      () => errRef.current.scrollIntoView({ behavior: "smooth", block: "end" }),
      100
    );
  };

  const [updateError, setUpdateError] = useState(false);
  const [updatedData, setUpdatedData] = useState({});
  const didMountRef = useRef(false);

  const updateDeliveryScheduleForecastData = useSelector(
    (state) =>
      state.pcmp.common.forecastSchedule?.updateDeliveryScheduleForecastData ||
      {}
  );
  const preUpdateDeliveryScheduleForecastData = usePrevious(
    updateDeliveryScheduleForecastData
  );

  useEffect(() => {
    if (didMountRef.current) {
      if (
        JSON.stringify(updateDeliveryScheduleForecastData) !==
        JSON.stringify(preUpdateDeliveryScheduleForecastData)
      ) {
        if (updateDeliveryScheduleForecastData.status === true) {
          // setLoading(false);
          setUpdateError(false);
          setUpdatedData(updateDeliveryScheduleForecastData);
          handleUpdateSuccess("New Delivery Schedule Proposed");
          //   setOpenSuccessDialog(true);
        } else if (updateDeliveryScheduleForecastData.status === false) {
          // setLoading(false);
          setUpdateError(true);
          //   scrollToTop();
          setUpdatedData(updateDeliveryScheduleForecastData);
          //   setOpenSuccessDialog(false);
        }
      }
    } else {
      didMountRef.current = true;
    }
  }, [
    updateDeliveryScheduleForecastData,
    preUpdateDeliveryScheduleForecastData,
  ]);

  return (
    <>
      <BackDropLoading />
      <Dialog
        open={openDialog}
        // onClose={closeProposeCounterPopup}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Grid item xs={12} className={classes.header}>
            <Grid item xs={12} className={classes.titleGrid}>
              <Grid item xs={12} className={classes.head}>
                {collaboratorTypeID === loggedInCollaboratorTypeID && (
                  <Typography
                    variant="h6"
                    style={{
                      fontSize: "1.4rem",
                      fontWeight: "bold",
                      textAlign: "start",
                    }}
                  >
                    Propose New Delivery Schedule
                  </Typography>
                )}

                {collaboratorTypeID !== loggedInCollaboratorTypeID && (
                  <Typography
                    variant="h6"
                    style={{
                      fontSize: "1.4rem",
                      fontWeight: "bold",
                      textAlign: "start",
                    }}
                  >
                    Propose Counter Schedule
                  </Typography>
                )}
              </Grid>
            </Grid>

            <Grid item xs={2} sm={2} md={2}>
              <Typography
                variant="body2"
                className={classes.closeBtn}
                onClick={handleDeliveryScehdulePopup}
              >
                Cancel{" "}
                <CloseIcon style={{ fontSize: "35px", color: "#FF0000" }} />
              </Typography>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Table
            style={{
              backgroundColor: "#E7F6FF",
              border: "1px solid #D3D3D3",
              tableLayout: "fixed",
              width: "100%", // Make the table take full width
            }}
            className={classes.table}
          >
            <TableHead>
              <TableRow style={{ height: "53px" }}>
                <TableCell className={classes.tableHeadCell}>
                  {" "}
                  {/* Fixed width for Drug ID */}
                  Drug ID
                </TableCell>
                <TableCell className={classes.tableHeadCell}>
                  {" "}
                  {/* Fixed width for Drug Name */}
                  Drug Name
                </TableCell>
                {localStorage.collabType !== 'CMO' ?
                  <TableCell className={classes.tableHeadCell}>
                    {" "}
                    {/* Fixed width for CDMO */}
                    CMO
                  </TableCell>
                  :
                  <TableCell className={classes.tableHeadCell}>
                    {" "}
                    {/* Fixed width for CDMO */}
                    Sponsor
                  </TableCell>
                }
                <TableCell className={classes.tableHeadCell}>
                  {" "}
                  {/* Fixed width for PO Details */}
                  PO Details
                </TableCell>
                <TableCell className={classes.tableHeadCell}>
                  {" "}
                  {/* Fixed width for Forecast Schedule ID */}
                  ForeCast Schedule ID
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow style={{ height: "53px" }}>
                <TableCell
                  style={{ whiteSpace: "nowrap" }}
                  className={classes.tableCell}
                >
                  {schedule.drugID}
                </TableCell>
                <TableCell
                  style={{ whiteSpace: "nowrap",overflow: "hidden",maxWidth: "auto"}}
                  className={classes.tableCell}
                >
                  {schedule.drugName}
                </TableCell>
                {localStorage.collabType !== 'CMO' ?
                  <TableCell
                    style={{ overflow: "hidden", maxWidth: "auto" }}
                    className={classes.tableCell}
                  >
                    {schedule.cdmoOrgName}
                  </TableCell>
                  :
                  <TableCell
                    style={{ overflow: "hidden", maxWidth: "auto" }}
                    className={classes.tableCell}
                  >
                    {schedule.sponsorOrgName}
                  </TableCell>
                }
                <TableCell
                  style={{ whiteSpace: "nowrap" }}
                  className={classes.tableCell}
                >
                  {`${schedule.poNumber} - ${schedule.poLineItemNumber}`}
                </TableCell>
                <TableCell
                  style={{ whiteSpace: "nowrap" }}
                  className={classes.tableCell}
                >
                  {schedule.collabrixForecastScheduleID}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>

          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Typography>
                {!hasProposedScheduleCDMOProp &&
                loggedInCollaboratorTypeID === 1
                  ? "Last Agreed Delivery Schedule"
                  : loggedInCollaboratorTypeID === 1
                  ? "Proposed CDMO Delivery Schedule"
                  : "Proposed Sponsor Delivery Schedule"}
              </Typography>
              <TableContainer component={Paper}>
                <Table size="small" style={{ tableLayout: "fixed" }}>
                  <TableHead>
                    <TableRow style={{ height: "53px" }}>
                      <TableCell>Date</TableCell>
                      <TableCell style={{ whiteSpace: "nowrap" }}>
                        Material Type
                      </TableCell>
                      <TableCell>Quantity</TableCell>
                      <TableCell>UoM</TableCell>
                    </TableRow>
                  </TableHead>

                  {dsForecastDetails.deliveryScheduleForecastDetailsList.map(
                    (row, index) => {
                      let selectedDate = null;
                      let selectedQuantity = "";
                      if (
                        !row.proposedDeliveryDateCDMO &&
                        loggedInCollaboratorTypeID === 1
                      ) {
                        selectedDate = row.lastAgreedDeliveryDate;
                      } else if (loggedInCollaboratorTypeID === 1) {
                        selectedDate = row.proposedDeliveryDateCDMO
                          ? row.proposedDeliveryDateCDMO
                          : row.lastAgreedDeliveryDate;
                      } else {
                        selectedDate = row.proposedDeliveryDateSponsor
                          ? row.proposedDeliveryDateSponsor
                          : row.lastAgreedDeliveryDate;
                      }

                      if (
                        !row.proposedQuantityCDMO &&
                        loggedInCollaboratorTypeID === 1
                      ) {
                        selectedQuantity = row.lastAgreedQuantity;
                      } else if (loggedInCollaboratorTypeID === 1) {
                        selectedQuantity = row.proposedQuantityCDMO
                          ? row.proposedQuantityCDMO
                          : row.lastAgreedQuantity;
                      } else {
                        selectedQuantity = row.proposedQuantitySponsor
                          ? row.proposedQuantitySponsor
                          : row.lastAgreedQuantity;
                      }

                      const formattedSelectedDate = selectedDate
                        ? moment(selectedDate).format("DD-MMM-YYYY")
                        : "-NA-";

                      return (
                        <TableBody key={index}>
                          <TableRow style={{ height: "53px" }}>
                            <TableCell
                              style={{
                                whiteSpace: "nowrap",
                                fontWeight:
                                  loggedInCollaboratorTypeID === 1 &&
                                  selectedDate === row.proposedDeliveryDateCDMO
                                    ? "bold"
                                    : loggedInCollaboratorTypeID === 2 &&
                                      selectedDate ===
                                        row.proposedDeliveryDateSponsor
                                    ? "bold"
                                    : "normal",
                                // fontWeight:
                                //   selectedDate ===
                                //     row.proposedDeliveryDateSponsor ||
                                //   selectedDate === row.proposedDeliveryDateCDMO
                                //     ? "bold"
                                //     : "normal",
                              }}
                            >
                              {formattedSelectedDate}
                            </TableCell>
                            <TableCell>{row.materialType}</TableCell>
                            <TableCell
                              style={{
                                fontWeight:
                                  loggedInCollaboratorTypeID === 1 &&
                                  selectedQuantity === row.proposedQuantityCDMO
                                    ? "bold"
                                    : loggedInCollaboratorTypeID === 2 &&
                                      selectedQuantity ===
                                        row.proposedQuantitySponsor
                                    ? "bold"
                                    : "normal",
                                // fontWeight:
                                //   selectedQuantity ===
                                //     row.proposedQuantitySponsor ||
                                //   selectedDate === row.proposedQuantityCDMO
                                //     ? "bold"
                                //     : "normal",
                              }}
                            >
                              {selectedQuantity}
                            </TableCell>
                            <TableCell>{row.uom}</TableCell>
                          </TableRow>
                        </TableBody>
                      );
                    }
                  )}
                </Table>
              </TableContainer>
            </Grid>

            <Grid item xs={6}>
              <Typography>
                {loggedInCollaboratorTypeID === 1
                  ? "Propose Sponsor Delivery Schedule"
                  : "Propose CDMO Delivery Schedule"}
              </Typography>
              <TableContainer component={Paper}>
                <Table size="small" style={{ tableLayout: "fixed" }}>
                  <TableHead>
                    <TableRow style={{ height: "53px", width: "100%" }}>
                      <TableCell style={{ width: "45%" }}>Date</TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", width: "25%" }}>
                        Material Type
                      </TableCell>
                      <TableCell style={{ width: "27%" }}>Quantity</TableCell>
                      <TableCell style={{ width: "10%" }}>UoM</TableCell>
                    </TableRow>
                  </TableHead>
                  {rows.map((row, index) => {
                    // const prevDate =
                    //   !hasProposedScheduleCDMOProp &&
                    //   !hasProposedScheduleSponsorProp
                    //     ? row.lastAgreedDeliveryDate
                    //     : loggedInCollaboratorTypeID === 1
                    //     ? row.proposedDeliveryDateSponsor
                    //     : row.proposedDeliveryDateCDMO;
                    let selectedDate = null;
                    let selectedQuantity = "";
                    if (loggedInCollaboratorTypeID === 1) {
                      selectedDate = row.proposedDeliveryDateSponsor
                        ? row.proposedDeliveryDateSponsor
                        : row.lastAgreedDeliveryDate;
                      selectedQuantity = row.proposedQuantitySponsor
                        ? row.proposedQuantitySponsor
                        : row.lastAgreedQuantity;
                    } else {
                      selectedDate = row.proposedDeliveryDateCDMO
                        ? row.proposedDeliveryDateCDMO
                        : row.lastAgreedDeliveryDate;
                      selectedQuantity = row.proposedQuantityCDMO
                        ? row.proposedQuantityCDMO
                        : row.lastAgreedQuantity;
                    }

                    const formattedSelectedDate = selectedDate
                      ? moment(selectedDate)
                      : null;

                    const isCurrentOrFutureDate = moment(
                      formattedSelectedDate
                    ).isSameOrAfter(moment(), "month");

                    // const selectedQuantity =
                    //   !row.proposedDeliveryDateSponsor &&
                    //   !row.proposedDeliveryDateCDMO
                    //     ? row.lastAgreedQuantity
                    //     : loggedInCollaboratorTypeID === 1
                    //     ? row.proposedQuantitySponsor
                    //     : row.proposedQuantityCDMO;

                    return (
                      <TableBody key={index}>
                        <TableRow style={{ height: "53px" }}>
                          {/* Date Field */}
                          <TableCell style={{ whiteSpace: "nowrap" }}>
                            {isCurrentOrFutureDate ? (
                              <MuiPickersUtilsProvider utils={MomentUtils}>
                                <DatePicker
                                  style={{ whiteSpace: "nowrap" }}
                                  variant="inline"
                                  inputVariant="outlined"
                                  format="DD-MMM-YYYY"
                                  value={
                                    formattedSelectedDate
                                      ? formattedSelectedDate
                                      : null
                                  }
                                  onChange={(date) => {
                                    handleDateChange(
                                      date,
                                      index,
                                      loggedInCollaboratorTypeID === 1
                                        ? "proposedDeliveryDateSponsor"
                                        : "proposedDeliveryDateCDMO"
                                    );
                                  }}
                                  size="small"
                                  autoOk={true}
                                  InputProps={{
                                    style: {
                                      fontWeight:
                                        loggedInCollaboratorTypeID === 1 &&
                                        selectedDate ===
                                          row.proposedDeliveryDateSponsor
                                          ? "bold"
                                          : loggedInCollaboratorTypeID === 2 &&
                                            selectedDate ===
                                              row.proposedDeliveryDateCDMO
                                          ? "bold"
                                          : "normal",
                                    },
                                    endAdornment: (
                                      <EventTwoToneIcon
                                        style={{
                                          color: "#0000008a",
                                          cursor: "pointer",
                                        }}
                                      />
                                    ),
                                  }}
                                />
                              </MuiPickersUtilsProvider>
                            ) : (
                              moment(row.lastAgreedDeliveryDate).format(
                                "DD-MMM-YYYY"
                              )
                            )}
                          </TableCell>

                          {/* Material Type */}
                          <TableCell>{row.materialType}</TableCell>

                          {/* Quantity Field */}
                          <TableCell style={{ whiteSpace: "nowrap" }}>
                            {isCurrentOrFutureDate ? (
                              <TextField
                                style={{ whiteSpace: "nowrap" }}
                                variant="outlined"
                                value={selectedQuantity ? selectedQuantity : ""}
                                onChange={(event) => {
                                  handleQuantityChange(
                                    event.target.value,
                                    index,
                                    loggedInCollaboratorTypeID === 1
                                      ? "proposedQuantitySponsor"
                                      : "proposedQuantityCDMO"
                                  );
                                }}
                                onBlur={(e) => {
                                  const { value } = e.target;
                                  // Trim leading and trailing spaces for string values
                                  if (typeof value === "string" && value.trim() !== value) {
                                    handleQuantityChange(value.trim(), index, loggedInCollaboratorTypeID === 1 ? "proposedQuantitySponsor" : "proposedQuantityCDMO");
                                  }
                                }}
                                size="small"
                                onInput={(event) => {
                                  event.target.value =
                                    event.target.value.replace(/[^0-9]/g, "");
                                }}
                                InputProps={{
                                  style: {
                                    fontWeight:
                                      loggedInCollaboratorTypeID === 1 &&
                                      selectedQuantity ===
                                        row.proposedQuantitySponsor
                                        ? "bold"
                                        : loggedInCollaboratorTypeID === 2 &&
                                          selectedQuantity ===
                                            row.proposedQuantityCDMO
                                        ? "bold"
                                        : "normal",
                                  },
                                }}
                              />
                            ) : (
                              row.uom
                            )}
                          </TableCell>

                          {/* UoM Field */}
                          <TableCell>{row.uom}</TableCell>
                        </TableRow>
                      </TableBody>
                    );
                  })}
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          style={{
            display: "flex",
            justifyContent: "space-around",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            endIcon={<ChevronRight />}
            style={{
              borderRadius: "20px",
              textTransform: "none",
            }}
            onClick={handleSave}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default NewDeliverySchedulePopup;
